import VueRouter from 'vue-router';

export function syncPageTitleWithRouteTitle(router: VueRouter) {
    router.beforeEach((to, _from, next) => {
        document.title = to.meta?.title;

        return next();
    });
}
